import React, {Component} from 'react'

function DisplayText(rules, programRulesVariables, values, field, fieldId) { 
    
    

    if(values != undefined) {
        if(values[fieldId] != undefined) {
            
        }
    }

    return field
}

export default DisplayText